import { render } from "./dictBasicalForm.vue?vue&type=template&id=71f7256c&scoped=true"
import script from "./dictBasicalForm.vue?vue&type=script&lang=js"
export * from "./dictBasicalForm.vue?vue&type=script&lang=js"

import "./dictBasicalForm.vue?vue&type=style&index=0&id=71f7256c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f7256c"]])

export default __exports__